import styled from "styled-components";
import { alpha_on_pressed } from "./CommonStyles";

export const AbsImage = styled.img`
  position: absolute;

  ${alpha_on_pressed};
  pointer-events: ${(p) => (p.onClick ? "auto" : "none")};
`;
